module.exports = "//static.hsappstatic.net/salesImages/static-1.403/sales-pro-onboarding/pql-modal/pql-documents@2x.png"